import {createApp} from 'vue'
import MemberListOverlayFrivillig from './MemberListOverlayFrivillig'

const el = '.kb-component--member-list-overlay-fvl'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MemberListOverlayFrivilligDOM)=>{

            const component = createApp(MemberListOverlayFrivillig).use(Store)
            component.mount(MemberListOverlayFrivilligDOM)
        })
    }
}